import UserService from '@/services/users'

export default {
  namespaced: true,
  state: {
    usersList: [],
  },
  getters: {
    getIndexOfUser: (state) => (id) => {
      return state.usersList.findIndex(user => user.id === id)
    }
  },
  mutations: {
    setUsers: (state, usersList) => state.usersList = usersList
  },
  actions: {
    async loadUsers ({commit}) {
      const usersList = await UserService.getAll()
      commit('setUsers', usersList)
    },
    async createUser ({state, commit}, user) {
      user.id = await UserService.create(user)
      if (user.file) {
        user.picture = await UserService.updatePicture(user.id, user.file) 
      }

      commit('setUsers', [...state.usersList, user])
      
    },
    async updateUser ({state, commit, getters}, user) {
      await UserService.update(user)
      if (user.file) {
        user.picture = await UserService.updatePicture(user.id, user.file)
      }
      const userIndex = getters.getIndexOfUser(user.id)

      let usersList = [...state.usersList]
      usersList[userIndex] = user
      commit('setUsers', usersList)
    },
    async deleteUser ({state, commit, getters}, id) {
      await UserService.delete(id)
      let usersList = [...state.usersList]
      usersList.splice(getters.getIndexOfUser(id), 1)
      commit('setUsers', usersList)
    },
  }
}